export default __webpack_public_path__ + "static/media/i-stack-2.0d934c70.svg";